import { forwardRef } from 'react';
// There is a bug when compiling in Pages Router that accessing the default export
// from next/image.js causes a "Element type is invalid" error in React. :shrug:
import { Image as NextImage } from 'next/dist/client/image-component.js';
import { getImageProps, type ImageLoader } from 'next/image.js';
import { useClientConfig } from '../../../config/react/use-client-config';
import { generateAssetPrefixFromName } from '../../../config/microfrontends-config/isomorphic/utils/generate-asset-prefix';

const CURRENT_ZONE = process.env.NEXT_PUBLIC_MFE_CURRENT_APPLICATION;

const loaderWithAssetPrefix =
  (assetPrefix: string, src: string): ImageLoader =>
  () =>
    `/${assetPrefix}${src}`;

/**
 * A Image component that prefixes microfrontend child zones with the asset prefix
 * to ensure the image request is routed to the correct zone.
 */
export const Image: typeof NextImage = forwardRef(
  ({ ...props }, ref): JSX.Element => {
    const { clientConfig } = useClientConfig(
      process.env.NEXT_PUBLIC_MFE_CLIENT_CONFIG,
    );

    const assetPrefix =
      CURRENT_ZONE && !clientConfig.applications[CURRENT_ZONE]?.default
        ? generateAssetPrefixFromName({ name: CURRENT_ZONE })
        : null;

    const {
      props: { src },
    } = getImageProps(props);

    return (
      <NextImage
        loader={
          assetPrefix ? loaderWithAssetPrefix(assetPrefix, src) : undefined
        }
        {...props}
        ref={ref}
      />
    );
  },
);
Image.displayName = 'MicrofrontendsImage';
